import React, { memo } from 'react'
// import useAmap from '../../../../hooks/use-amap/use-cluster'
import useAmap from '../../../../hooks/use-amap/use-marks'

const DefaultMap = ({ showTbDetail }) => {
  useAmap('viewmap', {
    showTbDetail,
  })

  const { mapType, showLabel, mainLayer } = useTbViewStore(
    (state) => state.mapConfig
  )

  const showArea = mapType === 'area'

  const { polygons } = useAmap('viewmap', {
    showArea,
    showTbDetail,
    showLabel,
  })

  if (!mainLayer) return null

  const { legends, legendsPosition } = mainLayer

  const onSwitch = useCallback((visible) => {
    if (visible) {
      polygons.current.show()
    } else {
      polygons.current.hide()
    }
  }, [])

  return (
    <div className="w-full h-full relative">
      <div id="viewmap" className="w-full h-full" />
    </div>
  )
}

export default memo(DefaultMap)
